import Vue from 'vue'
import { Icon, NavBar, Field, NumberKeyboard, Form, Button, Checkbox, Uploader,
ActionSheet, Dialog} from 'vant'
import App from './App.vue'
import router from './router'
import store from './store'
import 'lib-flexible'
import VueLazyload from 'vue-lazyload'
import { getRequest, postRequest, deleteRequest, putRequest, jsonPostRequest } from './assets/js/api'
// import VConsole from 'vconsole'
// import Cookies from 'js-cookie'
// 引入全部样式
import 'vant/lib/index.less'
import './assets/css/iconfont.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.prototype.getRequest = getRequest
Vue.prototype.postRequest = postRequest
Vue.prototype.jsonPostRequest = jsonPostRequest
Vue.prototype.deleteRequest = deleteRequest
Vue.prototype.putRequest = putRequest

Vue.config.productionTip = false
Vue.use(VueLazyload)
Vue.use(Icon)
Vue.use(NavBar)
Vue.use(Field)
Vue.use(Form)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(Uploader)
Vue.use(NumberKeyboard)
Vue.use(ActionSheet)
Vue.use(Dialog)

Vue.use(ElementUI)
// const vConsole = new VConsole()

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
